export default "__VITE_ASSET__BOAKU31y__";